import { Component, OnInit, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { GlobalService } from "app/services/global.service";
import { PageService } from "app/services/page-service";

@Component({
  selector: "app-delete-customer",
  templateUrl: "./delete-customer.component.html",
  styles: [],
})
export class DeleteCustomerComponent implements OnInit {
  @Input() data: any;
  loader = false;
  customerID = "";
  adminDetails = JSON.parse(localStorage.getItem("userDetails"));
  adminMailID = this.adminDetails["record"]["emailID"];
  password = "";
  confirmDelete = false;
  errorMsg = "";

  constructor(
    public dialogRef: NgbActiveModal,
    public global: GlobalService,
    public service: PageService
  ) {}

  ngOnInit(): void {
    this.customerID = this.data["customerID"];
  }

  close() {
    this.dialogRef.close({ success: false });
  }

  deleteCustomer() {
    this.loader = true;
    const authData = {
      login: {
        emailID: this.adminMailID,
        password: this.password,
      },
    };
    this.service
      .postMethod("aggregator/login", authData)
      .then((response) => {
        if (response["Success"]) {
          this.service
            .postMethod(`customer/deleteUserRecords/${this.customerID}`, {})
            .then((data) => {
              this.loader = false;
              this.dialogRef.close({ success: true });
            })
            .catch((err) => {
              this.loader = false;
              this.global.failureErrorModal(err);
            });
        }
      })
      .catch((err) => {
        console.log(err);
        this.loader = false;
        this.global.failureErrorModal(err["error"]["Error"]);
      });
  }

  confirm() {
    this.confirmDelete = true;
  }
}
